import { useEffect } from "react";

import { useGetOrgList } from "@src/api/organizations-list/get-organization-list";

import { useLoggedInUser } from "../api/user-auths/login";
import { mpLogin, mpViewPage } from "../utils/mixpanel";

export const useViewPage = (page: string) => {
  useEffect(() => {
    return () => {
      mpViewPage(page);
    };
  }, []);
};

export const useViewAnalyticsPage = (page: string) => {
  useEffect(() => {
    mpViewPage(page);
  }, [page]);
};

export const useMixpanelLogin = () => {
  const user = useLoggedInUser();
  const orgs = useGetOrgList();
  useEffect(() => {
    if (user.isSuccess && orgs.isSuccess) {
      mpLogin(user.data);
    }
  }, [user.isSuccess, orgs.isSuccess]);
};
